export default "__VITE_ASSET__Do847OLk__"